import * as pxp from '../lib/pxp'

/**
 * https://www.msmaster.qa.paypal.com/elmo/experiment/102787
 * Conditions:
 * - Control: serve content in html
 * - Treatment: serve content in generated js file
 */

export const isExternalizeContent = () =>
  pxp.isTreatment('Trmt_p2p_content_externalization')
